<template>
  <div class="wrapper">
    <Menu />

    <div class="header-area">
      <div class="container-fluid">
        <div class="row">
          <div class="col-6">
            <a @click="$router.go(-1)" href="javascript:;">
              <img src="/static/img/back-arrow.svg" class="pt-4 pb-4" />
            </a>
          </div>
          <div class="col-6 text-right"></div>
          <div class="col-12">
            <div class="tab-box">
              <div class="tab-header text-center bb-1 pr-0 pl-0">
                <div class="row no-gutters">
                  <div
                    class="col-6 tab-select pt-0"
                    :class="tab == 'future' ? 'active' : ''"
                    @click="changeTab('future')"
                  >
                    <h1 class="fs-18">Gelecek Maçlar</h1>
                  </div>
                  <div
                    class="col-6 tab-select pt-0"
                    :class="tab == 'past' ? 'active' : ''"
                    @click="changeTab('past')"
                  >
                    <h1 class="fs-18">Geçmiş Maçlar</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="body-area">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 p-0">
            <MatchVSFixture hideAll :data="item" v-for="item in data" :key="item.id" />
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>


<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Menu from "@/components/Menu";
import MatchVSFixture from "@/components/MatchVSFixture";
import axios from "axios";
export default {
  name: "Fixture",
  components: {
    Footer,
    Menu,
    Header,
    MatchVSFixture
  },
  data() {
    return {
      tab: "future"
    };
  },
  methods: {
    changeTab(tabName) {
      this.tab = tabName;
    }
  },
  beforeMount() {
    axios.post("mac-listesi/fikstur").then(res => {
      this.$store.state.matches = res.data.data;
    });
  },
  computed: {
    data() {
      return this.tab == "future"
        ? this.$store.state.matches.filter(k => k.isFinished == false)
        : this.$store.state.matches.filter(k => k.isFinished == true).reverse();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/Fixture.vue